import { RefObject, useLayoutEffect, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'

/* Hook to calculate the height of an ANT Design table. Since it does not have an integrated implementation. For the
purpose of scrolling it is required to calculate it based on its parent

Parameters:

@param parentContainer RefObject - Table's parent element reference
@param additionalContentHeight number - The table's header and footer are considered as additional content plus any
 other content you consider additional has to be calculated and pass as parameter to get the proper height of the table

* */
export const useTableHeight = (ref: RefObject<Element>, additionalContentHeight: number) => {
  const [tableHeight, setTableHeight] = useState<number>()
  const resizeTable = useDebouncedCallback(
    () => {
      const node = ref.current
      if (!node) {
        return
      }
      const { height } = node.getBoundingClientRect()
      setTableHeight(height - additionalContentHeight)
    },
    100,
    {
      trailing: true,
      maxWait: 100,
    },
  )

  useLayoutEffect(() => {
    resizeTable()
    window.addEventListener('resize', resizeTable)

    return () => {
      window.removeEventListener('resize', resizeTable)
    }
  }, [resizeTable, additionalContentHeight])

  return tableHeight
}
